const info = {
  CN: {
    relation: "相关内容",
    preP: "上一篇：无",
    nextP: "下一篇：上海万象城",
    pre: "上一篇：",
    next: "下一篇：",
    banner:
      //"http://resource.jmjnsz.com/jmjn-portal/2023/08/12/68db0f3b-fc81-4458-82ed-c34d6e44f021.jpg",
      "http://resource.jmjnsz.com/jmjn-portal/2026/04/02/ca1cef9f-b15e-4e3e-b42d-c9c2b903e69f.png"
  },
  EN: {
    relation: "Related content",
    preP: "Previous: None",
    nextP: "Next: The Mixc, Shanghai",
    pre: "Previous: ",
    next: "Next: ",
    banner:
      //"http://resource.jmjnsz.com/jmjn-portal/2023/08/12/1dd4ee42-f3cf-4051-ac4b-95fc0a5f9a55.jpg",
      "http://resource.jmjnsz.com/jmjn-portal/2026/04/02/267b846f-ed25-4d58-b073-a8d78fa3dd69.png",
  },
};
export default info;



// WEBPACK FOOTER //
// ./src/language/case/index.js